import ArrowCircleDown from "@/assets/icons/arrow-circle-down.svg?react";
import styles from "./variation-badge.module.scss";
import type { VariationBadgeProps, VariationBadgeViewModel } from "./types-variation-badge";

/**
 * Variação percentual do protótipo: a seta circular verde do Figma seguida do
 * valor.
 *
 * A seta é a única exceção ao texto branco da Home, por isso vem do próprio
 * desenho do Figma em vez do PrimeIcons. A alta reaproveita o mesmo traçado
 * girado — o círculo é simétrico —, e o sentido continua legível pelo sinal no
 * texto, nunca só pela cor.
 */
export function VariationBadgeView({
  direction,
  isDown,
  texto,
  suffix,
  testId,
}: VariationBadgeViewModel & Pick<VariationBadgeProps, "suffix" | "testId">) {
  return (
    <span className={styles.badge} data-testid={testId}>
      <ArrowCircleDown
        className={[styles.icon, isDown ? "" : styles.iconUp].filter(Boolean).join(" ")}
        role="img"
        aria-label={direction}
      />
      <span>{texto}</span>
      {suffix ? <span>{suffix}</span> : null}
    </span>
  );
}
